import React, { Fragment, useEffect, useState } from 'react';
import { Col, Container, Row, Table } from 'reactstrap';
import Select from "react-select";
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import _ from 'lodash';
import { SpinnerButton } from './';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { api, dateHelpers } from '../utils';
import CustomerTypeahead from "./CustomerTypeahead";


export default function ManageLateShipments() {
   const [customer, setCustomer] = useState(null);
   const [filtered, setFiltered] = useState([]);
   const [orders, setOrders] = useState([]);
   const [selectedOrder, setSelectedOrder] = useState(null);
   const [spinLateShip, setSpinLateShip] = useState(false);

   useEffect(() => {
      if (!customer?.value) {
         return;
      }
      getCustomerOrders();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [customer]);

   useEffect(() => {
      if (!selectedOrder?.value) {
         setFiltered([]);
         return;
      }
      getLateShipment();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [selectedOrder]);

   function deleteShipment(id) {
      setSpinLateShip(true);
      api.post(`Sales/DeleteLateShipment/${id}`)
         .then((r) => {
            if (r?.data?.success) {
               setFiltered(r.data.shipments);
               toast.success("Late record removed");
            }
            else if (r?.data?.message) {
               toast.error(r.data.message);
            }
            else {
               toast.error("An error occurred removing the late record");
            }
         })
         .catch(api.catchHandler)
         .finally(() => setSpinLateShip(false));
   }

   function getCustomerOrders() {
      let thisCust = customer?.value || "";
      api
         .fetch(`Sales/GetCustomerLateShipments/${thisCust}`)
         .then((response) => {
            if (response?.data?.success) {
               let list = _.map(response.data.orderList, (x) => {
                  return { value: x.orderType, label: x.orderId };
               });
               list.unshift({ value: "", label: "--- Orders ---" });
               setSelectedOrder({ value: "", label: "--- Orders ---" });
               setOrders(list);
            }
            else if (response?.data?.message) {
               toast.error(response.data.message);
            }
            else {
               toast.error("There was an error retrieving data for this customer");
            }
         })
         .catch(api.catchHandler);
   }

   function getLateShipment() {
      let custId = customer?.value || "";
      let ordId = selectedOrder?.label || "";
      api
         .fetch(`Sales/GetCustomerLateOrder/${custId}/${ordId}`)
         .then((response) => {
            if (response?.data?.success) {
               setFiltered(response.data.shipments);
            }
            else if (response?.data?.message) {
               toast.error(response.data.message);
            }
            else {
               toast.error("There was an error retrieving data for this order");
            }
         })
         .catch(api.catchHandler);
   }

   function onChangeCustomer(e) {
      setCustomer(e);
      setSelectedOrder({ value: "", label: "--- Orders ---" });
      setFiltered([]);
   }

   function onChangeOrder(e) {
      setSelectedOrder(e);
   }

   // Only this one late-shipment record (sales.LateShipment) is deleted - the wording says so, because "delete the
   // shipment" read as deleting the order itself. "This record", not "the late mark": an order can carry several late
   // records (106 orders on prod, 2026-10-15), and it stays late while any remain.
   const ShowDeleteModal = (id, orderId) => {
      if (id === 0) {
         toast.error("Please select a late shipment");
         return;
      }
      confirmAlert({
         title: "Remove Late Record",
         message: `Remove this late record from order ${_.trim(orderId)}? Only this record is deleted - the order and its shipment are not changed.`,
         buttons: [
            { label: "Yes", onClick: () => { deleteShipment(id) }},
            { label: "No" }
         ]
      });
   }

   return (
      <Container fluid>
         <Row>
            <Col>
               <Fragment>
                  <Row className="px-2 py-2">
                     <Col xxl={{ offset: 0, size: 12 }}>
                        <Table className="transparent-background my-0">
                           <tbody>
                              <tr>
                                 <td className="transparent-background data-cell noWrap h6" width="80px">
                                    Customer:
                                 </td>
                                 <td className="transparent-background" width="500px">
                                    <CustomerTypeahead value={customer || ""} onChange={(e) => onChangeCustomer(e)} />
                                 </td>
                                 <td className="transparent-background"></td>
                              </tr>
                              <tr>
                                 <td className="transparent-background data-cell noWrap h6" width="80px">
                                    Orders:
                                 </td>
                                 <td className="transparent-background" width="500px">
                                    <Select
                                       classNamePrefix="serviceThreadSelect"
                                       options={orders}
                                       value={selectedOrder}
                                       onChange={(e) => onChangeOrder(e)}
                                       getOptionValue={(option) => option}
                                    />
                                 </td>
                                 <td className="transparent-background"></td>
                              </tr>
                           </tbody>
                        </Table>
                     </Col>
                  </Row>
               
                  {filtered && filtered.length > 0 ? (
                     <div>
                        <Row className="px-0 py-0">
                           <Table className="transparent-background data-table">
                              <thead className="table-header">
                                 <tr>
                                    <th>Id</th>
                                    <th>Created</th>
                                    <th className="width115px">Created By</th>
                                    <th>Customer</th>
                                    <th className="width95px">Order</th>
                                    <th>ReqDate</th>
                                    <th>Reason</th>
                                    <th className="width115px">Reason Type</th>
                                    <th>Comment</th>
                                    <th></th>
                                 </tr>
                              </thead>
                              <tbody>
                                 {_.map(filtered, (datum, idx) => {
                                    return (
                                       <tr key={idx} className={`tr-${idx % 2 === 0 ? "primary" : "secondary"}`}>
                                          <td>{datum.id}</td>
                                          <td>{dateHelpers.formatDateToShortDate(datum.created)}</td>
                                          <td>{datum.createdBy}</td>
                                          <td>{datum.customerId}</td>
                                          <td>{datum.orderId}</td>
                                          <td>{dateHelpers.formatDateToShortDate(datum.reqDate)}</td>
                                          <td>{datum.reason}</td>
                                          <td>{datum.reasonType}</td>
                                          <td>{datum.comments}</td>
                                          <td>
                                             <SpinnerButton
                                                className="icon-button"
                                                color="danger"
                                                onClick={() => { ShowDeleteModal(datum.id, datum.orderId); }}
                                                title="Remove late record"
                                                on={spinLateShip}
                                                disabled={spinLateShip}
                                             >
                                                <FontAwesomeIcon className="whiteIcon" icon="trash" />
                                             </SpinnerButton>
                                          </td>
                                       </tr>
                                    )
                                 })}
                              </tbody>
                           </Table>
                        </Row>
                     </div>
                  ) : null}
               </Fragment>
            </Col>
         </Row>
      </Container>
   );
}
